var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4986 5.37C13.4536 5.3625 13.4011 5.3625 13.3561 5.37C12.3211 5.3325 11.4961 4.485 11.4961 3.435C11.4961 2.3625 12.3586 1.5 13.4311 1.5C14.5036 1.5 15.3661 2.37 15.3661 3.435C15.3586 4.485 14.5336 5.3325 13.4986 5.37Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7256 10.8301C13.7531 11.0026 14.8856 10.8226 15.6806 10.2901C16.7381 9.58512 16.7381 8.43012 15.6806 7.72512C14.8781 7.19262 13.7306 7.01262 12.7031 7.19262",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47688 5.37C4.52188 5.3625 4.57438 5.3625 4.61938 5.37C5.65438 5.3325 6.47937 4.485 6.47937 3.435C6.47937 2.3625 5.61688 1.5 4.54438 1.5C3.47188 1.5 2.60938 2.37 2.60938 3.435C2.61687 4.485 3.44188 5.3325 4.47688 5.37Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24812 10.8301C4.22062 11.0026 3.08812 10.8226 2.29313 10.2901C1.23563 9.58512 1.23563 8.43012 2.29313 7.72512C3.09563 7.19262 4.24312 7.01262 5.27062 7.19262",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99859 10.9716C8.95359 10.9641 8.90109 10.9641 8.85609 10.9716C7.82109 10.9341 6.99609 10.0866 6.99609 9.03656C6.99609 7.96406 7.85859 7.10156 8.93109 7.10156C10.0036 7.10156 10.8661 7.97156 10.8661 9.03656C10.8586 10.0866 10.0336 10.9416 8.99859 10.9716Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81656 13.3345C5.75906 14.0395 5.75906 15.1945 6.81656 15.8995C8.01656 16.702 9.98156 16.702 11.1816 15.8995C12.2391 15.1945 12.2391 14.0395 11.1816 13.3345C9.98906 12.5395 8.01656 12.5395 6.81656 13.3345Z",
    stroke: "#A4A1B3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.64cbc04fc0c3e558979b9f30f52206a0.svg";
export { ForwardRef as ReactComponent };